import type { NavigateFunction } from 'react-router-dom';

export function navigableProps(navigate: NavigateFunction, to: string) {
  return {
    onClick: (e: React.MouseEvent) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        window.open(to, '_blank');
        return;
      }
      navigate(to);
    },
    onMouseDown: (e: React.MouseEvent) => {
      if (e.button === 1) {
        e.preventDefault();
      }
    },
    onMouseUp: (e: React.MouseEvent) => {
      if (e.button === 1) {
        e.preventDefault();
        window.open(to, '_blank');
      }
    },
  };
}
